import { render, staticRenderFns } from "./BaseLoader.vue?vue&type=template&id=e01a435e&scoped=true"
import script from "./BaseLoader.vue?vue&type=script&lang=js"
export * from "./BaseLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01a435e",
  null
  
)

export default component.exports